
document.addEventListener('DOMContentLoaded', function () {
    const cepInput = document.getElementById('CEP');

    if (!cepInput) return;

    function limpar_campos_cep() {
        document.getElementById('Endereco').value = '';
        document.getElementById('Bairro').value = '';
        document.getElementById('IDCidade').value = '';
    }

    cepInput.addEventListener('blur', function () {
        const cep = this.value.replace(/\D/g, '');
        if (!cep) return;

        const validacep = /^[0-9]{8}$/;
        if (!validacep.test(cep)) {
            limpar_campos_cep();
            return;
        }

        fetch(`https://hub.sfhera.net/api/consulta/cep/${cep}`, {
            method: 'GET',
            headers: {
                'Authentication': 'Bearer fPf32mjozbyvX1B1hPlv8QtP2',
                'Identificador': '04492741000198'
            }
        })
            .then(response => {
                if (!response.ok) throw new Error('Erro na requisição');
                return response.json();
            })
            .then(data => {
                const enderecoInput = document.getElementById('Endereco');
                const bairroInput = document.getElementById('Bairro');
                const cidadeInput = document.getElementById('IDCidade');

                if (data && data.logradouro) {
                    cidadeInput.value = data.codigoIBGE || '';
                    cidadeInput.dispatchEvent(new Event('change'));
                    enderecoInput.value = data.logradouro.toUpperCase();
                    bairroInput.value = (data.bairro || '').toUpperCase();
                } else {
                    limpar_campos_cep();
                }
            })
            .catch(error => {
                console.error('Erro ao buscar o CEP:', error);
                limpar_campos_cep();
            });
    });
});